import React, { FC } from 'react';

export interface AuthDividerProps {
    className?: string;
    label?: string;
}

/** The "OR" rule between two ways of signing in. Same markup the template used. */
const AuthDivider: FC<AuthDividerProps> = ({ className = '', label = 'OR' }) => (
    <div className={`relative text-center ${className}`}>
        <span className="relative z-10 inline-block px-4 text-sm font-medium bg-white dark:bg-neutral-900 dark:text-neutral-400">
            {label}
        </span>
        <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
    </div>
);

export default AuthDivider;
